import { Promise } from 'core-js'
import Vue from 'vue'

import Feed from './services/feed'

const store = new Vue.observable({
  ready: false,
  patching: false,
  feed: [],
  pagination: {

  },
  hiddenFeed: [],
  hiddenPagination: {

  },
})

const FeedCollection = {
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  reset: () => {
    store.ready = false
    store.patching = false
    store.feed = []
    store.pagination = {}
  },
  init: async (patch) => {
    if(!patch) FeedCollection.reset()
    else store.patching = true

    await Feed.clear()
    await new Promise((resolve) => setTimeout(resolve,1000))
    let result = await Feed.get({ ignoreCache: true }).then(({ data }) => data)

    let { data, metadata } = result;

    //set feed details
    Vue.set(store, 'feed', data);
    Vue.set(store, 'pagination', metadata);

    let hiddenResult = await Feed.getHidden({ ignoreCache: true }).then(({ data }) => data)

    let { data: hiddenData, metadata: hiddenMetadata } = hiddenResult;

    //set feed details
    Vue.set(store, 'hiddenFeed', hiddenData);
    Vue.set(store, 'hiddenPagination', hiddenMetadata);

    console.log("FeedCollection", store);

    store.ready = true
    store.patching = false
  },
  refresh: (patch) => {
    if (!store.ready || store.patching) return
    console.log("can refresh")
    FeedCollection.init(patch)
  },

  list: () => store.feed,
  getPagination: () => store.pagination,

  listHidden: () => store.hiddenFeed,
  getHiddenPagination: () => store.hiddenPagination
}

export default FeedCollection